export default {
  title: "月報出力",
  outputConditions: "出力条件",
  preCreate: "事前集計",
  driver: "ドライバー",
  vehicle: "車両",
  messages: {
    displayCurrentMonth: "当月を表示しています",
    confirmClear: "月報をクリアしてもよろしいですか？",
    clearSuccess: "クリアしました。",
    clearError: "エラー: {message}",
    clearValidationError: "バリデーションエラー:\n{errors}",
    clearFailed: "月報のクリアに失敗しました。"
  },
  list: {
    all: "ドライバー or 車両",
    inputWorkingTimes: "出社・退社時間入力",
    clear: "クリア",
  },
  searchForm: {
    aggregationTarget: "集計対象",
    monthly: "月分"
  },
  button: {
    download: "ダウンロード",
    downloading: "ダウンロード中..."
  },
  outputLayout: {
    ledger: "帳票",
    format: "フォーマット",
    byDriverPreview: "乗務員別労働実績明細表",
    laborSummaryTable: "乗務員別労働実績一覧表",
    noticeExceeding: "改善基準告示超過表",
    byVehiclePreview: "車両別稼働実績明細表",
    vehicleSummaryTable: "車両別稼働実績一覧表"
  },
  preCreateStatus: {
    loading: "読み込み中...",
    total: "合計",
    inQueue: "処理待ち",
    inProgress: "処理中",
    skipped: "スキップ",
    succeeded: "成功",
    failed: "失敗",
    unconfirmed: "未確定"
  },
  preCreateButton: {
    bulkAggregate: "一括集計",
    aggregate: "集計",
    bulkAggregateStarted: "一括集計バッチが開始されました"
  }
}
